export function isBoneRequired(obsType: string) {
  return obsType === "LESION" || obsType === "FRACT";
}
